import { useEffect, useState } from 'react'

export type PreviewDevice = 'desktop' | 'tablet' | 'mobile'

export const DEVICE_WIDTH: Record<PreviewDevice, number> = {
  desktop: 1440,
  tablet: 768,
  mobile: 390,
}

/** Debounce helper used by the editor to throttle preview requests. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(t)
  }, [value, delayMs])
  return debounced
}
